export default __webpack_public_path__ + "static/media/replay_button.6b4752e5.svg";